import axios from 'axios'
import Vue from 'vue'

import {Toast} from "vant"
import {getToken, clearToken} from "@/utils/auth"

const BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api'

const request = axios.create({
    baseURL: BASE_URL, // Base URL: The base URL for all requests
    timeout: 5000, // Timeout: Request timeout duration
    // headers: {platform: 'h5'} // Headers: Custom headers for each request
})

// Customize request interceptors
request.interceptors.request.use(config => {
    Toast.loading(
        {
            message: "loading...",
            forbidClick: true,
            duration: 0
        }
    )
    // 管理端 API 需要帶 JWT；公開 API 收到這個 header 也不影響（後端不會看）
    const token = getToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Customize response interceptor
request.interceptors.response.use(response => {
    const res = response.data
    console.log(res)
    if (res.code !== 200) {
        Toast(res.msg ? res.msg : 'Network Error')
        // token 失效/過期：清掉本機儲存的 token，避免後續請求繼續帶著壞掉的 token 打過去。
        // 不在這裡直接導頁——router 沒有反向 import 這個檔案，避免循環依賴；
        // 導頁交給呼叫端（admin 頁面的 catch block）自己判斷 error.code === 401 處理。
        if (res.code === 401) {
            clearToken()
        }
        return Promise.reject({ code: res.code, msg: res.msg })
    } else {
        Toast.clear()
    }
    return res
}, error => {
    Toast.clear()
    return Promise.reject(error)
})

export default request